import type { ReactNode } from "react";
import { Header } from "./Header.tsx";
import { Footer } from "./Footer.tsx";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-surface text-text-primary">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
